import { isAfter } from 'owa-datetime';
import type { Todo, Subtodo } from 'owa-todo-types';

/**
 * Compares todos | subtodos by OrderDateTime.
 * This comparison can be used to sort todos from most recent OrderDateTime to least recent.
 * @param todo1 todo | subtodo to compare
 * @param todo2 todo | subtodo to compare
 * @returns Returns -1 if todo1 is after todo2. Returns 1 if todo1 is before or at the same time as todo2.
 */
export function compareTodosByOrderDateTime(todo1: Todo, todo2: Todo): number;
export function compareTodosByOrderDateTime(todo1: Subtodo, todo2: Subtodo): number;
export function compareTodosByOrderDateTime(todo1, todo2) {
    return isAfter(todo1.OrderDateTime, todo2.OrderDateTime) ? -1 : 1;
}

/**
 * Compares todos by CommittedOrder.
 * This comparison can be used to sort todos from most recent CommittedOrder to least recent.
 * @param todo1 todo to compare
 * @param todo2 todo to compare
 * @returns Returns -1 if todo1 is after todo2. Returns 1 if todo1 is before or at the same time as todo2.
 */
export function compareTodosByCommittedOrder(todo1: Todo, todo2: Todo): number {
    return isAfter(todo1.CommittedOrder, todo2.CommittedOrder) ? -1 : 1;
}
